import React, { useState } from 'react';
import { Box, Button, Typography, TextField, Snackbar } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useTranslation } from 'react-i18next';
import { gtmNewsletterSubmit } from '../../utils/gtm';

const ShareBar = ({ data }) => {
  const { t, i18n } = useTranslation();
  const s = 'calc.share';
  const [copied, setCopied] = useState(false);

  const buildShareURL = () => {
    const params = new URLSearchParams();
    if (data.province) params.set('prov', data.province.toLowerCase());
    if (data.yearsInCanada) params.set('year', data.yearsInCanada);
    if (data.objective) params.set('obj', data.objective);
    if (data.income) params.set('income', data.income);
    if (data.employerMatch) params.set('match', data.employerMatch);
    if (data.contribution) params.set('contribution', data.contribution);
    const lng = i18n.language || 'es';
    return `${window.location.origin}/${lng}/herramientas/calculadora-rrsp-vs-tfsa?${params.toString()}`;
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(buildShareURL());
      setCopied(true);
    } catch { /* fallback */ }
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 3 }}>
        <Button
          variant="outlined"
          startIcon={<ContentCopyIcon />}
          onClick={handleCopy}
          sx={{ textTransform: 'none', borderColor: '#EEF0F3', color: '#1E3A5F' }}
        >
          {t(`${s}.copyLink`)}
        </Button>
      </Box>

      {/* Email capture */}
      <Box
        sx={{
          bgcolor: '#FAFBFD', border: '1px solid #EEF0F3', borderRadius: 3, p: 3,
        }}
      >
        <Typography sx={{ fontSize: 14, fontWeight: 600, color: '#1A1A1A', mb: 1.5 }}>
          {t(`${s}.emailLabel`)}
        </Typography>
        <Box
          component="form"
          action="https://buttondown.com/api/emails/embed-subscribe/Finmaple"
          method="post"
          target="_blank"
          onSubmit={() => {
            if (window.plausible) window.plausible('Newsletter Submit', { props: { source: 'rrsp-calc' } });
            gtmNewsletterSubmit({ source: 'rrsp-calc' });
          }}
          sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}
        >
          <TextField
            type="email"
            name="email"
            placeholder="tu@email.com"
            size="small"
            required
            sx={{ flex: 1, minWidth: 200, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
          <input type="hidden" name="tag" value="rrsp-calc" />
          <Button
            type="submit"
            variant="contained"
            sx={{
              bgcolor: '#1E3A5F', textTransform: 'none', fontWeight: 700,
              '&:hover': { bgcolor: '#1A3152' },
            }}
          >
            {t(`${s}.emailCTA`)}
          </Button>
        </Box>
        <Typography sx={{ fontSize: 12, color: '#5F6B7A', mt: 1 }}>
          {t(`${s}.noSpam`)}
        </Typography>
      </Box>

      <Snackbar
        open={copied}
        autoHideDuration={2000}
        onClose={() => setCopied(false)}
        message={t(`${s}.linkCopied`)}
      />
    </Box>
  );
};

export default ShareBar;
